import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as FelaThemeProvider } from 'react-fela';
export function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(FelaThemeProvider, {
    theme: theme,
    overwrite: false
  }, children);
}
ThemeProvider.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
};